import React from 'react';
import { RFValue } from 'react-native-responsive-fontsize';
import Svg, { Path, Rect, Defs, LinearGradient, Stop } from 'react-native-svg';

interface CouponTicketProps {
  color?: string;   // hex da cor principal, ex: "#E53935" para vermelho
  width?: number;
  height?: number;
}

/**
 * Ícone de "cupom não encontrado" (ticket de combustível).
 * Toda a arte usa a mesma cor base (prop `color`), variando apenas
 * a opacidade para criar o efeito de gradiente/sombra e os quadrados
 * decorativos. Basta trocar o hex para re-tingir a imagem inteira.
 */
export default function CouponTicket({
  color = '#22C55E',
  width = RFValue(100),
  height = RFValue(80),
}: CouponTicketProps) {
  return (
    <Svg width={width} height={height} viewBox="0 0 946 578" fill="none">
      <Defs>
        <LinearGradient id="ticketGradient" x1="150" y1="70" x2="800" y2="510" gradientUnits="userSpaceOnUse">
          <Stop offset="0" stopColor={color} stopOpacity="0.55" />
          <Stop offset="1" stopColor={color} stopOpacity="1" />
        </LinearGradient>
      </Defs>

      {/* Quadrados decorativos */}
      <Rect x="0" y="8" width="72" height="72" rx="14" fill={color} fillOpacity="0.28" />
      <Rect x="874" y="164" width="72" height="72" rx="14" fill={color} fillOpacity="0.28" />
      <Rect x="826" y="490" width="80" height="80" rx="14" fill={color} fillOpacity="0.28" />
      <Rect x="0" y="462" width="34" height="34" rx="6" fill={color} />

      {/* Corpo do ticket */}
      <Path
        d="M110 152 C110 116.65 138.65 88 174 88 H772 C807.35 88 836 116.65 836 152 V232
           C807.35 232 784 255.35 784 284.5 C784 313.65 807.35 337 836 337 V417
           C836 452.35 807.35 481 772 481 H174 C138.65 481 110 452.35 110 417 V337
           C138.65 337 162 313.65 162 284.5 C162 255.35 138.65 232 110 232 Z"
        fill="url(#ticketGradient)"
      />

      {/* Linha tracejada central */}
      <Path
        d="M566 88 V481"
        stroke="#FFFFFF"
        strokeOpacity="0.55"
        strokeWidth="8"
        strokeDasharray="18 16"
      />

      {/* Ícone de bomba de combustível (Font Awesome "gas-pump", viewBox 0 0 512 512) */}
      {/* Escalado (~0.28x) e posicionado no centro esquerdo do ticket */}
      <Path
        transform="translate(248, 190) scale(0.35)"
        d="M32 64C32 28.7 60.7 0 96 0L256 0c35.3 0 64 28.7 64 64l0 192 8 0c48.6 0 88 39.4 88 88l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-154c-27.6-7.1-48-32.2-48-62l0-59.5-25.8-28.3c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l71.7 78.8c9.4 10.3 14.6 23.7 14.6 37.7L512 376c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-32c0-22.1-17.9-40-40-40l-8 0 0 161.4c9.3 3.3 16 12.2 16 22.6 0 13.3-10.7 24-24 24L40 512c-13.3 0-24-10.7-24-24 0-10.5 6.7-19.3 16-22.6L32 64zM96 80l0 96c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L112 64c-8.8 0-16 7.2-16 16z"
        fill="#FFFFFF"
        fillOpacity="0.92"
      />
    </Svg>
  );
}
